module.exports = __webpack_public_path__ + "static/media/tally.1c9a5fa2.png";